/**
 * Classe para centralizar os relatórios que cadastramos em SagresEntrega.rel.relatorios.
 *
 * @since 20230816
 */
export class Relatorio {
  DsRelatorio: string;
  IdRelatorio: number;
  LogVisualizacao: any[];
  NomeRelatorio: string;
  Ordem: number;
  Params: string;
  PathRelatorio: string;
  RelatorioPcm: any[];
  TipoEntrega: string;

  /**
   * retorna se algum LogVisualização possui confirmação.
   *
   * @since 20230822
   */
  possuiConfirmacao(): boolean {
    if (this.LogVisualizacao && this.LogVisualizacao.length)
      return this.LogVisualizacao.some((lv) => lv.DataConfirmacao !== null);
    return false;
  }
}
